import styled from 'styled-components';

export const XAxisTitle = styled.div<{
  graphWidth?: number;
  marginLeft: number;
}>`
  display: flex;
  width: ${(props) => (props.graphWidth ? `${props.graphWidth}px` : 'auto')};
  flex-direction: column;
  align-items: center;
  margin-left: ${(props) => `${props.marginLeft}px`};
  padding-top: 20px;
`;

export const BarHorizontalSvgContainer = styled.div<{ height?: string }>`
  ${(props) => (props.height ? `height: ${props.height};` : '')}
  width: 100%;
  padding-left: 20px;
`;

export const BarHorizontalAndAxisContainer = styled.div`
  width: 100%;
`;

export const ScrollableDiv = styled.div<{
  width: string;
  height: string;
  marginTop: string;
  marginBottom: string;
  hasScroll: boolean;
}>`
  overflow-y: ${(props) => (props.hasScroll ? 'auto' : 'hidden')};
  overflow-x: hidden;
  ${(props) =>
    props.hasScroll
      ? `
    mask-image: linear-gradient(to top, ${props.theme.atlas.semantic.color.surface.default}00 0px, ${props.theme.atlas.semantic.color.surface.default} 50px);
    padding-bottom: 10px;
    border-bottom: 1px solid ${props.theme.atlas.semantic.color.surface.default};`
      : ''}
  ${(props) => `width: ${props.width};
                height: ${props.height};
                margin-top: ${props.marginTop};
                margin-bottom: ${props.marginBottom};`}
`;
